module.exports = __webpack_public_path__ + "static/media/contemplar_te_7.1b2289ee.jpg";